import Card from "@mui/material/Card";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./finalisefs.css";
import swal from 'sweetalert';
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddFooters from "./footers";
import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import standalonecss from "../../myfin_v2/css/standalone.module.css"
import { Button } from "../../myfin_v2/elements/Button";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
import { addSignatoryApiHandler, deleteSignatoryApiHandler, editSignatoryApiHandler, finalizeFSFormatApiHandler, getFinalizeFSApiHandler, consolFinalizeFSFormatApiHandler, getPopulateFSExportFSApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import AddEditSignatory from "./AddEditSignatory";
import Signatory from "./Signatory";
import ExportPages from "./ExportPages";
import QuillReactEditor from "../../myfin_v2/components/QuillReactEditor";
import sigCss from "../../myfin_v2/css/textEditor.module.css";
import addSignCard from "../../myfin_v2/assets/icons/addSignCard.png";
import cardHover from "../../myfin_v2/assets/icons/cardHover.png";

const FinaliseFs = () => {
  const project_id = localStorage.getItem("project_id");

  const units_values = [
    "whole numbers",
    "hundreds",
    "thousands",
    "lakhs",
    "crores",
    "millions",
  ];
  const decimal_values = [0, 1, 2, 3];
  
  const [removeNullFields, setRemoveNullFields] = useState(false);
  const [unit, setUnit] = useState("whole numbers");
  const [decimal, setDecimal] = useState(0);
  const [checkBoxList] = useState([
  { label: "Balance Sheet", value: "BS" },
  { label: "Profit & Loss", value: "PL" },
  { label: "Cashflow", value: "cashflow" },
  { label: "Cashflow Workings", value: "cashflow workings" },
  { label: "SOCIE", value: "socie" },
  { label: "Profit & Loss Notes", value: "PL notes" },
  { label: "Disclosure", value: "disclosure" },
  { label: "Disclosure Checklist", value: "disclosure checklist" },
  { label: "General Notes", value: "general notes" },
  { label: "Balance Sheet Notes", value: "BS notes" }
]);


  const workspace_data = useSelector((state) => state.WSReducer);
  const { projectData } = useSelector((state) => state.ADJStandaloneReducer);
  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
  const standaloneName = projectData?.project_name || sessionStorage.getItem("adj_standalone_name") || localStorage.getItem("projectName") || "Standalone";

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: `/myfinV2/standalonefs`,
      className: "headerLable clickable",
    },
    {
      label: standaloneName,
      link: `/myfinV2/standalonefs`,
      className: "headerLable clickable",
    },
    { label: "Finalise FS", link: "", className: "headerLable" },
  ];

  const headerSections = [
    "Balance Sheet",
    "Statement of Profit & Loss",
    "Cashflow",
    "Statement of Change in Equity",
    "General Notes",
    "Balance Sheet Notes",
    "Profit & Loss Notes",
    "Disclosure",
  ];

  const footerSections = [
    "Balance Sheet",
    "Statement of Profit & Loss",
    "Cashflow",
    "Statement of Change in Equity",
    "General Notes",
    "Balance Sheet Notes",
    "Profit & Loss Notes",
    "Disclosure",
  ];

  const [activeHeader, setActiveHeader] = useState("Balance Sheet");
  const [activeFooter, setActiveFooter] = useState("Balance Sheet");
  const [selectedFooters, setSelectedFooters] = useState([]);
  const [selectedExportPages, setSelectedExportPages] = useState([]);
  const [showAddEditSignatoryModal, setShowAddEditSignatoryModal] = useState(false);
  const [signatoryList, setSignatoryList] = useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const createInitialSections = (sections) =>
  sections.reduce((acc, section) => {
    acc[section] = "";
    return acc;
  }, {});

const [headerContent, setHeaderContent] = useState( createInitialSections(headerSections));

const [footerContent, setFooterContent] = useState( createInitialSections(footerSections));

  const [formData, setFormData] = useState({
    "_id": null,
    "category": null,
    "firmName": null,
    "firmRole": null,
    "firmNumber": null,
    "auditorName": null,
    "auditorRole": null,
    "membershipNumber": null,
    "directorName": null,
    "directorRole": null,
    "directorNumber": null,
    "place": null,
    "date": null
  });

  const handleUnitDecimal = (e) => {
    if (e.target.name === "unit") {
      setUnit(e.target.value);
    } else {
      setDecimal(e.target.value);
    }
  };

  const exportFS = (exportAs) => {
    const params = {
      projectID: project_id,
      fileType: exportAs,
    };

    getPopulateFSExportFSApiHandler(params)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          {
            type:
              exportAs === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const fileUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;

        downloadLink.download =
          exportAs === "pdf"
            ? `FS_${project_id}.pdf`
            : `FS_${project_id}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch((error) => {
        console.error("exportFS error:", error);
      });
  };

  const getFinalizeFS = () => {
    getFinalizeFSApiHandler(project_id).then(response => {
      const finalizeFSFormat = response.data.finalizeFSFormat
      const signatoryList = response.data.signatoryList
      
      setUnit(finalizeFSFormat?.units ?? "whole numbers")
      setDecimal(finalizeFSFormat?.decimals ?? 0)
      setSelectedFooters(finalizeFSFormat?.addFooterTo ?? [])
      setSelectedExportPages(finalizeFSFormat?.exportPages ?? [])
      setRemoveNullFields(finalizeFSFormat?.removeNullField ?? false)
      setSignatoryList(signatoryList ?? [])

      setHeaderContent({
        "Balance Sheet": finalizeFSFormat?.BSHeader ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLHeader ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesHeader ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesHeader ?? "",
        "Cashflow": finalizeFSFormat?.cashflowHeader ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieHeader ?? "",
        "Disclosure": finalizeFSFormat?.disclosureHeader ?? "",
        "General Notes": finalizeFSFormat?.generalNotesHeader ?? "",
      })

      setFooterContent({
        "Balance Sheet": finalizeFSFormat?.BSFooter ?? "",
        "Statement of Profit & Loss": finalizeFSFormat?.PLFooter ?? "",
        "Balance Sheet Notes": finalizeFSFormat?.BSNotesFooter ?? "",
        "Profit & Loss Notes": finalizeFSFormat?.PLNotesFooter ?? "",
        "Cashflow": finalizeFSFormat?.cashflowFooter ?? "",
        "Statement of Change in Equity": finalizeFSFormat?.socieFooter ?? "",
        "Disclosure": finalizeFSFormat?.disclosureFooter ?? "",
        "General Notes": finalizeFSFormat?.generalNotesFooter ?? "",
      });
        setIsInitialLoad(false);
    }).catch(error => {
      swal("Error", "Error: Get Finalize FS API Failed!", "error");
    });

  }

  const handleFSFormat = () => {
    const addIfNotEmpty = (obj, fieldName, value) => {
      if (value && value.trim() !== "") {
        obj[fieldName] = value;
      }
    };

    const finalizeFSFormat = {
      units: unit,
      decimals: decimal,
      exportPages: selectedExportPages,
      addFooterTo: selectedFooters,
      removeNullField: removeNullFields,
    };

    addIfNotEmpty(finalizeFSFormat, "BSHeader", headerContent["Balance Sheet"]);
    addIfNotEmpty(finalizeFSFormat, "BSFooter", footerContent["Balance Sheet"]);
    
    addIfNotEmpty(finalizeFSFormat, "PLHeader", headerContent["Statement of Profit & Loss"]);
    addIfNotEmpty(finalizeFSFormat, "PLFooter", footerContent["Statement of Profit & Loss"]);
    
    addIfNotEmpty(finalizeFSFormat, "BSNotesHeader", headerContent["Balance Sheet Notes"]);
    addIfNotEmpty(finalizeFSFormat, "BSNotesFooter", footerContent["Balance Sheet Notes"]);
    
    addIfNotEmpty(finalizeFSFormat, "PLNotesHeader", headerContent["Profit & Loss Notes"]);
    addIfNotEmpty(finalizeFSFormat, "PLNotesFooter", footerContent["Profit & Loss Notes"]);
    
    addIfNotEmpty(finalizeFSFormat, "cashflowHeader", headerContent["Cashflow"]);
    addIfNotEmpty(finalizeFSFormat, "cashflowFooter", footerContent["Cashflow"]);
    
    addIfNotEmpty(finalizeFSFormat, "socieHeader", headerContent["Statement of Change in Equity"]);
    addIfNotEmpty(finalizeFSFormat, "socieFooter", footerContent["Statement of Change in Equity"]);
    
    addIfNotEmpty(finalizeFSFormat, "disclosureHeader", headerContent["Disclosure"]);
    addIfNotEmpty(finalizeFSFormat, "disclosureFooter", footerContent["Disclosure"]);
    
    addIfNotEmpty(finalizeFSFormat, "generalNotesHeader", headerContent["General Notes"]);
    addIfNotEmpty(finalizeFSFormat, "generalNotesFooter", footerContent["General Notes"]);

    const payload = { finalizeFSFormat };

    finalizeFSFormatApiHandler({ projectID: project_id }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setHasUnsavedChanges(false);
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update Finalise FS format",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update Finalise FS format",
          "error"
        );
      });
  };

  const handleSaveAuditor = (formData) => {
    const payload = {
      category: formData.category,
      place: formData.place,
      date: formData.date,

      ...(formData.category === "auditor" && {
        firmName: formData.firmName,
        firmRole: formData.firmRole,
        firmNumber: formData.firmNumber,
        auditorName: formData.auditorName,
        auditorRole: formData.auditorRole,
        membershipNumber: formData.membershipNumber,
      }),

      ...(formData.category === "board of directors" && {
        directorName: formData.directorName,
        directorRole: formData.directorRole,
        directorNumber: formData.directorNumber,
      }),
    };

    if (formData?._id) {
      saveModifiedSignatoryHandler(payload, formData?._id);
    } else {
      addSignatoryHandler(payload);
    }
  }

  const addSignatoryHandler = (payload) => {
    addSignatoryApiHandler({ projectID: project_id }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory added successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to add Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to add Signatory",
          "error"
        );
      });
  }

  const saveModifiedSignatoryHandler = (payload, signId) => {
    editSignatoryApiHandler({ projectID: project_id, signatoryID: signId }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setShowAddEditSignatoryModal(false);
          swal("Signatory updated successful", "", "success");
          getFinalizeFS();
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update Signatory",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update Signatory",
          "error"
        );
      });
  }

  const handleDeleteSignatory = (signId) => {
    swal({
      title: "Confirm deletion of Signatory",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteSignatoryApiHandler({ projectID: project_id, signatoryID: signId })
          .then((response) => {
            if (response?.data?.success === true) {
              swal("Signatory deleted successfully", "", "success");
              getFinalizeFS();
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to deleted Signatory",
                "error"
              );
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to deleted Signatory",
              "error"
            );
          });
      }
    });
  }

  const editSignatory = (signId) => {
    const modifySignatory = signatoryList.find((sign) => sign._id === signId)

    setFormData({
      "_id": modifySignatory?._id ?? null,
      "category": modifySignatory?.category ?? null,
      "firmName": modifySignatory?.firmName ?? null,
      "firmRole": modifySignatory?.firmRole ?? null,
      "firmNumber": modifySignatory?.firmNumber ?? null,
      "auditorName": modifySignatory?.auditorName ?? null,
      "auditorRole": modifySignatory?.auditorRole ?? null,
      "membershipNumber": modifySignatory?.membershipNumber ?? null,
      "directorName": modifySignatory?.directorName ?? null,
      "directorRole": modifySignatory?.directorRole ?? null,
      "directorNumber": modifySignatory?.directorNumber ?? null,
      "place": modifySignatory?.place ?? null,
      "date": modifySignatory?.date ?? null
    })
    setShowAddEditSignatoryModal(true);
  }

  useEffect(() => {
    getFinalizeFS();
  }, [])

 useEffect(() => {
  if (isInitialLoad) return;

  if (unit !== null && decimal !== null) {
    handleFSFormat();
  }
}, [unit, decimal, selectedFooters, selectedExportPages, removeNullFields]);

useEffect(() => {
  if (isInitialLoad) return;

  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }

  const timeout = setTimeout(() => {
    handleFSFormat();
  }, 2000);

  setDebounceTimeout(timeout);

  return () => clearTimeout(timeout);

}, [headerContent, footerContent]);


  useEffect(() => {
    if (showAddEditSignatoryModal === false) {
      setFormData({
        "_id": null,
        "category": null,
        "firmName": null,
        "firmRole": null,
        "firmNumber": null,
        "auditorName": null,
        "auditorRole": null,
        "membershipNumber": null,
        "directorName": null,
        "directorRole": null,
        "directorNumber": null,
        "place": null,
        "date": null
      })
    }
  }, [showAddEditSignatoryModal])

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} 
            className={commoncss.w100} 
            style={{ maxHeight: "95vh", overflowY: "hidden" }}
          >
            <div className="fscp-header" style={{ padding: "15px 20px" }}>
              <Breadcrumb 
                style="margin-right:auto"
                addCls={"bgTransprent"}
                p0={true}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as Excel"
                onClick={() => { exportFS("excel") }}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as PDF"
                onClick={() => { exportFS("pdf") }}
              />
            </div>

            <div className="mx-3">
              <div className={standalonecss.finaliseFSDiv}>
                <div className="d-flex mt-4 ml-3" style={{ gap: "105px", justifyContent: "space-between", alignItems: "center" }}>
                  {/* Units Dropdown */}
                  <div style={{ display: "flex", flexDirection: "column", width: "210px" }}>
                    <FormControl fullWidth>
                      {/* <InputLabel
                        id="unit-value-select-label"
                        shrink={unit !== null && unit !== undefined && unit !== ""}
                        sx={{
                          "&.Mui-focused": { color: "#B3C0BD" },
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#B3C0BD",
                          top: "-5px"
                        }}
                      >
                        Units
                      </InputLabel> */}
                      <Select
                        labelId="unit-value-select-label"
                        id="unit-value-select"
                        value={unit}
                        name="unit"
                        onChange={handleUnitDecimal}
                        input={<OutlinedInput />}
                        
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          width: "300px",
                          height: "40px",
                          backgroundColor: "#F4FAF5",
                          borderRadius: "10px",
                          fontSize: "14px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                        }}
                         MenuProps={{
                          PaperProps: {
                            sx: {
                              backgroundColor: "#ffffff",
                              borderRadius: "4px",
                              boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                              mt: 1,
                            },
                          },
                        }}
                      >
                        {units_values.map((item, key) => (
                          <MenuItem value={item} key={key}
                          sx={{
                          "&:hover": {
                            backgroundColor: "#F8F9F9",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#C2E6D1 !important",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#C2E6D1",
                          },
                           "&.Mui-focusVisible": {
                              backgroundColor: "#C2E6D1 !important",
                            },
                        }}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", width: "250px" }}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="decimal-value-select-label"
                        shrink={decimal !== null && decimal !== undefined && decimal !== ""}
                        sx={{
                          "&.Mui-focused": { color: "#B3C0BD" },
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#B3C0BD",
                          top: "-5px"
                        }}
                      >
                        {/* Decimals */}
                      </InputLabel>
                      <Select
                        labelId="decimal-value-select-label"
                        id="decimal-value-select"
                        value={decimal}
                        name="decimal"
                        onChange={handleUnitDecimal}
                        input={<OutlinedInput />}
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          width: "300px",
                          height: "40px",
                          backgroundColor: "#F4FAF5",
                          borderRadius: "10px",
                          fontSize: "14px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                        }}
                        MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                            mt: 1,
                          },
                        },
                      }}
                        
                      >
                        {decimal_values.map((item, key) => (
                          <MenuItem value={item} key={key}
                          sx={{
                          "&:hover": {
                            backgroundColor: "#F8F9F9",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#C2E6D1 !important",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#C2E6D1",
                          },
                           "&.Mui-focusVisible": {
                            backgroundColor: "#C2E6D1 !important",
                          },
                        }}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      paddingRight: "30px",
                      cursor: "pointer",
                      marginLeft: "auto",
                    }}
                    onClick={() => setRemoveNullFields(!removeNullFields)}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "16px",
                        borderRadius: "20px",
                        backgroundColor: removeNullFields ? "#2D8861" : "#CCD5D3",
                        position: "relative",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          backgroundColor: "white",
                          position: "absolute",
                          top: "0px",
                          left: removeNullFields ? "18px" : "0px",
                          transition: "all 0.3s ease",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                    <span style={{ fontSize: "16px", fontWeight: 500, color: "#205A46" }}>
                      Remove Null Fields
                    </span>
                  </div>
                </div>

                <div className="p-3">
                  {/* HEADER Card */}
                  <Card className="pb-10" style={{ borderRadius: "10px", border: "1px solid #CCD5D3", marginBottom: "20px" }}>
                    <div className={standalonecss.finaliseFSSecHeader}>
                      <span style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} `}>HEADER</span>
                    </div>
                    <div className={sigCss.headerWrapper}>
                      <div className={sigCss.leftHeaderContainer}>
                        {headerSections.map((item) => (
                          <div
                            key={item}
                            onClick={() => { handleFSFormat(); 
                              setActiveHeader(item);
                            }}
                            className={`${sigCss.headerItem} ${
                              activeHeader === item ? sigCss.activeHeaderItem : ""
                            }`}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div className={sigCss.rightHeaderEditor}>
                        <div style={{ flex: 1 }}>
                          <QuillReactEditor
                            key={activeHeader} 
                            greyToolbar={true}
                            value={headerContent[activeHeader] || ""}
                            onChange={(data) => {
                            const html = data.html;

                            setHeaderContent(prev => {
                              if (prev[activeHeader] === html) return prev;
                              return { ...prev, [activeHeader]: html };
                            });

                            setHasUnsavedChanges(true);
                          }}
                          />
                        </div>
                      </div>
                    </div>
                  </Card>

                  {/* FOOTER Card */}
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3", marginBottom: "20px" }}>
                    <div className={standalonecss.finaliseFSSecHeader}>
                      <span style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} `}>FOOTER</span>
                    </div>
                    <div className={sigCss.headerWrapper}>
                      <div className={sigCss.leftHeaderContainer}>
                        {footerSections.map((item) => (
                          <div
                            key={item}
                            onClick={() => {
                              handleFSFormat();
                              setActiveFooter(item);
                            }}

                            className={`${sigCss.headerItem} ${
                              activeFooter === item ? sigCss.activeHeaderItem : ""
                            }`}
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                      <div className={sigCss.rightHeaderEditor}>
                        <QuillReactEditor
                          key={activeFooter} 
                          greyToolbar={true}
                          value={footerContent[activeFooter] || ""}
                          onChange={(data) => {
                            const html = data.html;

                            setFooterContent(prev => {
                              if (prev[activeFooter] === html) return prev;
                              return { ...prev, [activeFooter]: html };
                            });

                            setHasUnsavedChanges(true);
                          }}
                        />
                      </div>
                    </div>
                  </Card>

                  {/* SIGNATORY Card */}
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}>
                      <span style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} `}>SIGNATORY</span>
                    </div>
                    <AddFooters
                      checkBoxList={checkBoxList}
                      selectedItems={selectedFooters}
                      setSelectedItems={setSelectedFooters}
                      setShowAddEditSignatoryModal={setShowAddEditSignatoryModal}
                    />
                    <div style={{ maxHeight: "48vh", overflowY: "auto", padding: "30px" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "50px", alignItems: "stretch" }}>
                        {signatoryList.map((signatory) => (
                          <Signatory 
                            key={signatory._id} 
                            signatory={signatory} 
                            editSignatory={editSignatory} 
                            handleDeleteSignatory={handleDeleteSignatory} 
                          />
                        ))}
                        <div onClick={() => setShowAddEditSignatoryModal(true)} className={sigCss.addSignatoryCard} style={{
                          "--icon-normal": `url(${addSignCard})`,
                          "--icon-hover": `url(${cardHover})`,
                        }}>
                          Add New <br /> Signatory
                        </div>
                      </div>
                    </div>
                  </Card>

                  {/* EXPORT PAGES Card */}
                  <Card className="pb-2 mt-3" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}>
                      <span style={{ letterSpacing: "1px" , fontWeight: "900"}} className={`ml-3 ${commoncss.fs15} `}>EXPORT PAGES</span>
                    </div>
                    <ExportPages
                      checkBoxList={checkBoxList}
                      selectedItems={selectedExportPages}
                      setSelectedItems={setSelectedExportPages}
                    />
                  </Card>
                </div>
              </div>
            </div>
            {showAddEditSignatoryModal && (
              <AddEditSignatory 
                setShowAddEditSignatoryModal={setShowAddEditSignatoryModal} 
                formData={formData} 
                setFormData={setFormData} 
                onSave={handleSaveAuditor} 
              />
            )}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default FinaliseFs;